import styled from '@emotion/native';
import React from 'react';
import CloseGreen from '@/assets/images/CloseGreen.png';

interface ModalCloseButtonProps {
  onPress: () => void;
}

const ModalCloseButton = ({ onPress }: ModalCloseButtonProps) => {
  return (
    <CloseButton onPress={onPress}>
      <Image source={CloseGreen} />
    </CloseButton>
  );
};

const CloseButton = styled.TouchableOpacity({
  position: 'absolute',
  top: 21,
  right: 23,
});

const Image = styled.Image({
  width: 24,
  height: 24,
});

export default ModalCloseButton;
